import React, { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { useCatalog } from "@/context/CatalogContext";

export function SplashLoader() {
  const { ready, error, progress, retry } = useCatalog();
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    if (ready || error) return undefined;
    const t = setTimeout(() => setSlow(true), 8000);
    return () => clearTimeout(t);
  }, [ready, error]);
  if (ready) return null;
  return (
    <div className="fixed inset-0 z-[200] bg-[#0a0a0f] flex items-center justify-center" data-testid="splash-loader">
      <div className="w-[min(420px,86vw)] text-center">
        <div className="font-display font-black uppercase tracking-tight text-3xl sm:text-4xl text-white mb-1">POMATA</div>
        <div className="font-mono text-[11px] uppercase tracking-[0.4em] text-red-500 mb-10">In Session</div>
        {error ? (
          <div data-testid="splash-error">
            <p className="text-white/70 font-semibold mb-1">No se pudo cargar la música</p>
            <p className="text-white/40 text-sm mb-6">El servidor está tardando en responder.</p>
            <button type="button" onClick={retry} data-testid="splash-retry"
              className="btn-red text-white px-6 py-2.5 rounded-full font-semibold inline-flex items-center gap-2">
              <RefreshCw className="w-4 h-4" /> Reintentar
            </button>
          </div>
        ) : (
          <>
            <div className="h-1.5 bg-white/10 rounded-full overflow-hidden" data-testid="splash-progress">
              <div className="h-full bg-red-600 shadow-[0_0_14px_rgba(229,9,20,0.8)]" style={{ width: `${progress}%`, transition: "width 300ms ease-out" }} />
            </div>
            <div className="mt-3 font-mono text-[11px] uppercase tracking-[0.3em] text-white/40" data-testid="splash-progress-label">
              {progress < 40 ? "Conectando" : progress < 90 ? "Cargando catálogo" : "Preparando"}… {Math.round(progress)}%
            </div>
            {slow && (
              <div className="mt-6 text-sm text-white/50" data-testid="splash-slow">
                Está tardando más de lo normal…{" "}
                <button type="button" onClick={() => window.location.reload()} className="text-red-500 underline underline-offset-4" data-testid="splash-reload">recargar</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
